import { create } from 'zustand';

interface RecordingState {
    recordingType: 'video' | 'audio' | null;
    setRecordingType: (type: 'video' | 'audio' | null) => void;
}

export const useRecordingState = create<RecordingState>((set) => ({
    recordingType: null,
    setRecordingType: (type) => set({ recordingType: type }),
}));
